<template>
  <v-container class="py-0 px-5">
    <validated-text-field
      v-model="password.password"
      class="mb-0"
      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
      :type="show ? 'text' : 'password'"
      color="secondary"
      field-name="password"
      prepend-icon="mdi-lock-outline"
      vid="confirmation"
      rules="required"
      autofocus
      @click:append.prevent="show = !show"
    />
    <validated-text-field
      v-model="password.password_confirmation"
      class="mb-0"
      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
      :type="show ? 'text' : 'password'"
      color="secondary"
      field-name="password_confirmation"
      prepend-icon="mdi-lock-outline"
      rules="required|confirmed:confirmation"
      @click:append.prevent="show = !show"
    />
  </v-container>
</template>

<script>
  export default {
    name: 'EditUserPassword',
    props: {
      password: Object,
    },
    data () {
      return {
        show: false,
      }
    },
  }
</script>
